import { render, staticRenderFns } from "./PageDashboardNewLayout.vue?vue&type=template&id=7a081fbe"
import script from "./PageDashboardNewLayout.vue?vue&type=script&lang=js"
export * from "./PageDashboardNewLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports